<template>
  <a href="javascript:void(0);" class="hovers" style="width: 243px; display: block;">
    <div :show_report_50bang="pageAdInfo.show_report_50bang" :uid="pageAdInfo.uid" :compName="compName">
      <div :id="pageAdInfo.divId"></div>
    </div>
  </a>
</template>
<script>
import ad from '../../api/ad';
import util from '../../api/util';
import stats from '../../api/statistics';

export default {
  name: 'NewsTplRightAdBaidu',
  props: ['newsAdInfo', 'compName', 'pageType'],
  data () {
    return {
      pageAdInfo: {},
      iframeRect: {
        stop: 0,
        wheight: 0
      }
    };
  },
  mounted () {
    this.$bus.$on('showRight', (data) => {
      this.iframeRect = data.rect;
      this.showReport();
    });
    this.$bus.$on('showReport', (data) => {
      this.iframeRect = data.rect;
      this.showReport();
    });
    this.initAdsInfo();
  },
  methods : {
    /**
     * 广告初始化
     */
    initAdsInfo () {
      this.pageAdInfo = this.newsAdInfo;
      this.$nextTick(() => {
        let dependJs = 'https://newsie.2345.cc/newtab/common/e2_bdm.js';
        if (!!document.querySelector(`script[src="${dependJs}"]`)) { // JS文件已加载
          if (window.hasOwnProperty('BAIDU_CLB_fillSlotAsync')) { // 异步方法挂载完成
            ad.getAdsList('bdwm', {
              divId: this.newsAdInfo.divId,
              uid: 'u4804554'
            });
            this.showReport();
          } else { // JS已加载， 但是方法尚未初始化完成
            setTimeout(() => {
              ad.getAdsList('bdwm', {
                divId: this.newsAdInfo.divId,
                uid: this.newsAdInfo.uid
              });
              this.showReport();
            }, 200);
          }
        } else {
          util.loadJs(dependJs, () => {
            ad.getAdsList('bdwm', {
              divId: this.newsAdInfo.divId,
              uid: this.newsAdInfo.uid
            });
            this.showReport();
          });
        }
      });
    },
    showReport () {
      if (document.querySelector(('#' + this.pageAdInfo.divId))) {
        if (util.isElementInViewport(this.pageAdInfo.divId, this.iframeRect, this.pageType) && this.pageAdInfo['show_report_50bang'] !== 'reported') {
          stats.ajax99(this.pageAdInfo.show_report_50bang);
          // console.log('reported', `${this.pageAdInfo.divId}-${this.pageAdInfo.show_report_50bang}-showrepoted`, this.pageAdInfo.divId, this.iframeRect);
          this.pageAdInfo['show_report_50bang'] = 'reported';
        }
      }
    }
  }
}
</script>
